import {Component, OnInit} from '@angular/core';
import {SelectLocationTable} from '../../../../shared/location-select.table';
import {Select2OptionData} from 'ng-select2';
import {Options} from 'select2';
import {SelectFieldsTable} from '../../../../jobboard/shared/select-fields.table';
import {DropdownDataTable} from '../../../shared/dropdown-data.table';
import {CandidatesDataService} from '../../candidates/candidates-data.service';
import {HttpClient} from '@angular/common/http';
import {CompanyDataService} from '../../../../jobboard/components/pages/company-account/company-data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ClientsDataService} from '../clients-data.service';
import { NgForm } from '@angular/forms';


@Component({
    selector: 'app-clients-list',
    templateUrl: './clients-list.component.html',
    styleUrls: ['./clients-list.component.scss'],
    providers: [SelectLocationTable, SelectFieldsTable, DropdownDataTable]

})
export class ClientsListComponent implements OnInit {
    constructor(private http: HttpClient,
                private selectFields: SelectFieldsTable,
                private route: ActivatedRoute,
                private router: Router,
                private clientService: ClientsDataService,
                private dropdownSelect: DropdownDataTable){}

    size: number = 3;
    pageSizes = [3, 6, 9];
    page: number = 1;
    totalElements: number;
    isOpen: boolean;


    public domainOptions: Options;
    public subDomainOptions: Options;
    public singleSelect: Options;

    companiesData: any = {};
    companyName: string;
    fiscalCode: string;
    activitySector: any;
    companyActivitySubSector: any;
    companyType: string = '';
    companyEmployeesLevel: string = '';
    rating: number = 0;

    clientsMainArray: any = [];
    clientsNameArray: any = [] ;
    dataLoaded: boolean;

    filteredCompanies: any = [];

    selectedDomain: string = "Selecteaza domeniu";
    selectCompany: string = "Tasteaza numele sau CUI-ul companiei..."

    domains = this.selectFields.domains;
    domainsArrayValues: Array<any>;

    subdomains: Array<any> = [];

    order: string;
    sort: string;

    sortingValues = this.dropdownSelect.clientsSorting;

    // Change Domain event, if domain not empty fill the subdomains list
    changeDomain(domain: any) { //Angular 11
        if (domain != '') {
            this.subdomains = this.domains.find((dmn: any) => dmn.name == domain).subdomains; //Angular 11
        } else {
            this.subdomains = [];
        }
    }

    ngOnInit() {


        this.subdomains = [];
        let domainsArray = [];
        this.domains.forEach(function (value) {
            let domain = value.name;
            domainsArray.push(domain);
        });
        this.domainsArrayValues = domainsArray;
        this.domainsArrayValues.unshift("");

        this.domainOptions = {
            width: '100%',
            multiple: false
        }

        this.subDomainOptions = {
            width: '100%',
            multiple: true
        }

        this.singleSelect = {
            width: '100%',
            multiple: false
        }

        this.clientService.getAllCompanies().subscribe(companies => {
            this.clientsMainArray = companies;
            this.clientsMainArray.forEach((value) => {
                this.clientsNameArray.push({id: value.id, text: value.companyName + ' (' + value.fiscalCode +')'});
            });
            this.dataLoaded = true;
        })

        this.companiesCall();
    }

    goToCompany() {
        this.companiesData = {
            companyName: this.selectCompany != "" ? this.selectCompany : undefined,
        }

        this.router.navigate(['/sistemerp/clienti/vizualizare/' + this.companiesData.companyName]);
    }

    resetForm(searchForm: NgForm){
        // this.activitySector = '';
        // this.companyActivitySubSector = '';
        // this.companyType = '';
        // this.companyEmployeesLevel = '';
        // this.rating = 0;
        searchForm.resetForm()
        this.companiesData = {}
        this.clientService.listCompaniesFiltered(this.size, this.page, this.sort, this.order, this.companiesData).subscribe(companies => {
            this.filteredCompanies = companies;
            this.totalElements = this.filteredCompanies.totalElements;
        }, error => {
        });

    }

    companiesCall(){

        this.companiesData = {
            // companyName: this.companyName != "" ? this.companyName : undefined,
            // fiscalCode: this.fiscalCode != "" ? this.fiscalCode : undefined,
            activitySector: this.activitySector != "" ? this.activitySector : undefined,
            companyActivitySubSector: this.companyActivitySubSector != "" ? this.companyActivitySubSector : undefined,
            companyType: this.companyType != "" ? this.companyType : undefined,
            companyEmployeesLevel: this.companyEmployeesLevel != "" ? this.companyEmployeesLevel : undefined,
            rating: this.rating != 0 ? this.rating : undefined,
        }

        this.clientService.listCompaniesFiltered(this.size, this.page, this.sort, this.order, this.companiesData).subscribe(companies => {
            this.filteredCompanies = companies;
            this.totalElements = this.filteredCompanies.totalElements;
        }, error => {
        });
    }

    onPageChange(page: number) {
        this.page = page;
        this.companiesCall();
    }

    onSizeChange(event: any) {
        this.size = event.target.value;
        this.page = 1;
        this.companiesCall();
    }

    onSortChange(event: any) {
        this.sort = event.target.value;
        this.page = 1;
        this.companiesCall();
    }

    onOrderChange(event: any) {
        this.order = event.target.value;
        this.page = 1;
        this.companiesCall();
    }

}
